import { api } from '@/modules/shared/lib/axios'
import type { ResponseAPI } from '@/modules/shared/types/response-api.type'

import type { ScheduleFormData } from '../types/schedule-form-data.type'

export function updateScheduleService(payload: ScheduleFormData) {
  return api.put<ResponseAPI>('agendamento', payload)
}
